// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_array from "../../../../../../../node_modules/rescript/lib/es6/js_array.js";
import * as Js_string from "../../../../../../../node_modules/rescript/lib/es6/js_string.js";

var websiteBookingFlowRoutes = [
  "fare-estimate",
  "fare_estimate_mob",
  "order-review",
  "track-order",
  "order-history",
  "trucks",
  "bikes",
  "two-wheelers"
];

function isWhitelistedRoute(router, is_desktop) {
  return Js_array.some((function (whitelistedRoute) {
                return Js_string.includes(whitelistedRoute, router.pathname);
              }), websiteBookingFlowRoutes);
}

export {
  websiteBookingFlowRoutes ,
  isWhitelistedRoute ,
}
/* No side effect */
